// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-content[data-v-7228fb33]{max-height:67vh;max-width:51rem;overflow:hidden scroll;padding:0 1.5rem}@media screen and (max-width:1140px){.dialog-content[data-v-7228fb33]{max-width:75vw}}", ""]);
// Exports
module.exports = exports;
